<ng-container>
    <div class="header">
        <div class="title">
            <h3>Pannello di Amministrazione - Eventi Costa Crociere</h3>
        </div>

      @if (userService.displayName) {
        <div class="login">
          <p [matMenuTriggerFor]="menu2">{{userService.displayName}}</p>
          <mat-menu class="menu-user" #menu2="matMenu">
            <ul>
              <li (click)="logout()">Esci</li>
            </ul>
          </mat-menu>
        </div>
      }
    </div>

  
    <div class="container">
        <router-outlet></router-outlet>
    </div>

    @if (testCookies) {
      <div style="padding: 25px;">
        <p>I COOKIES sono disabilitati</p>
      </div>
    }

    <!-- <hr class="line"> -->
    <div class="footer">
        <img src="/assets/img/costa.png" alt="logoCosta" width="80px">
    </div>
</ng-container>

<app-spinner></app-spinner>
